/* DEAR SOPHIE — dane do faktury w koszyku (25.08.2026).
   Zapisuje atrybuty koszyka "Firma" i "NIP" przez /cart/update.js.
   Nasluch delegowany na document, bo szuflada koszyka przerysowuje swoja tresc
   (data-merge), co zerwaloby nasluch podpiety bezposrednio do pol. */
(function () {
  if (window.dsFakturaInit) return;
  window.dsFakturaInit = true;

  var timer = null;

  function el(id) {
    return document.getElementById(id);
  }

  function save() {
    var chk = el('CartDrawerFakturaChk');
    var firma = el('CartDrawerFirma');
    var nip = el('CartDrawerNIP');
    var on = chk ? chk.checked : false;
    var url = (window.theme && theme.routes && theme.routes.cartUpdate) ? theme.routes.cartUpdate : '/cart/update.js';

    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          Firma: on && firma ? firma.value.trim() : '',
          NIP: on && nip ? nip.value.replace(/[^0-9]/g, '') : ''
        }
      })
    });
  }

  function saveSoon() {
    clearTimeout(timer);
    timer = setTimeout(save, 400);
  }

  document.addEventListener('input', function (evt) {
    if (!evt.target || !evt.target.id) return;
    if (evt.target.id === 'CartDrawerFirma' || evt.target.id === 'CartDrawerNIP') saveSoon();
  });

  document.addEventListener('change', function (evt) {
    if (!evt.target || evt.target.id !== 'CartDrawerFakturaChk') return;
    var pola = el('CartDrawerFakturaPola');
    if (pola) pola.style.display = evt.target.checked ? '' : 'none';
    if (evt.target.checked) {
      var firma = el('CartDrawerFirma');
      if (firma) firma.focus();
    } else {
      clearTimeout(timer);
      save();
    }
  });
})();